// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Assets_pageContainer__2J3Ly","title":"Assets_title__3mq4a","description":"Assets_description__2ZDFL"};